import { Outlet } from 'react-router-dom';
import { Container } from '@material-ui/core';
import Footer from './footer';

export default function PublicLayout() {
  return (
    <>
      <Container>
        <Outlet />
      </Container>
      <Footer />
    </>
  );
}
